import Vue from 'vue'
import Router from 'vue-router'
import Home from '../components/home'
import Services from '../components/services'
import Product from '../components/product'
import Blog from '../components/blog'
import Support from '../components/support'
import About from '../components/about'
import Help from '../components/help'
import Detail from '../components/detail'
import Landingpage from '../components/landingpage'
import Oline from '../components/online'
import Shopify from '../components/shopify'
import Woocommerce from '../components/woocommerce'
import Bigcommerce from '../components/bigcommerce'
import AntDiy from '../components/antDiy'
import AntSupply from '../components/antSupply'
import AntDiyPro from '../components/antDiyPro'
import ProductCN from '../components/productscn'
import homeCN from '../components/homecnNew'
import solve from '../components/solve'
import solutionRaas from '../components/solutionRaas'
import solutionBaas from '../components/solutionBaas'
import AboutCN from '../components/aboutcn'
import Getstore from '../components/getstore'
import BlogCN from '../components/blogcn'
import DetailCN from '../components/detailcn'
import CloudShop from '../components/VXPublicAcount/cloudShop.vue'
import CustomizedReport from '../components/VXPublicAcount/customizedReport.vue'
import PrivateReport from '../components/VXPublicAcount/privateReport.vue'
import Tiktoksupply from '../components/VXPublicAcount/tiktoksupply.vue'


Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    // {
    //   path: '/',
    //   name: 'Home',
    //   component: Home,
    //   redirect: '/home',
    //   meta:{
    //     keepAlive: true
    //   },
    // },
    // {
    //   path: '/',
    //   name: 'Detail',
    //   component: Detail,
    //   meta:{
    //     keepAlive: true
    //   },
    // },
    {
      path: '/home',
      name: 'Home',
      component: Home,
      meta:{
        keepAlive: true
      },
    },
    {
      path: '/services',
      name: 'Services',
      component: Services,
      meta:{
        keepAlive: true
      },
    },
    {
      path: '/products',
      name: 'Product',
      component: AntDiyPro,
      meta:{
        keepAlive: true
      },
    },
    {
      path: '/antdiy',
      name: 'AntDiy',
      component: AntDiy,
      meta:{
        keepAlive: true
      },
    },
    {
      path: '/antdiypro',
      name: 'AntDiyPro',
      component: AntDiyPro,
      meta:{
        keepAlive: true
      },
    },
    {
      path: '/antsupply',
      name: 'AntSupply',
      component: AntSupply,
      meta:{
        keepAlive: true
      },
    },
    {
      path: '/blog',
      name: 'Blog',
      component: Blog,
      meta:{
        keepAlive: true
      },
    },
    {
      path: '/support',
      name: 'Support',
      component: Support,
      meta:{
        keepAlive: true
      },
    },
    {
      path: '/about',
      name: 'About',
      component: About,
      meta:{
        keepAlive: true
      },
    },
    {
      path: '/help',
      name: 'Help',
      component: Help,
      meta:{
        keepAlive: true
      },
    },
    {
      path: '/detail',
      name: 'Detail',
      component: Detail,
      meta:{
        keepAlive: true
      },
    },
    {
      path: '/landingpage',
      name: 'Landingpage',
      component: Landingpage,
      meta:{
        keepAlive: false
      },
    },
    {
      path: '/getstore',
      name: 'Getstore',
      component: Getstore,
      meta:{
        keepAlive: true
      },
    },
    {
      path: '/online',
      name: 'Oline',
      component: Oline,
      meta:{
        keepAlive: true
      },
    },
    {
      path: '/shopify',
      name: 'Shopify',
      component: Shopify,
      meta:{
        keepAlive: true
      },
    },
    {
      path: '/woocommerce',
      name: 'Woocommerce',
      component: Woocommerce,
      meta:{
        keepAlive: true
      },
    },
    {
      path: '/bigcommerce',
      name: 'Bigcommerce',
      component: Bigcommerce,
      meta:{
        keepAlive: true
      },
    },
    {
      path: '/cn',
      redirect: '/cn/home',
    },
    {
      path: '/cn/home',
      name: 'homeCN',
      component: homeCN,
      meta:{
        keepAlive: true
      },
    },
    {
      path: '/cn/products',
      name: 'ProductCN',
      component: ProductCN,
      meta:{
        keepAlive: true
      },
    },
    {
      path: '/cn/solve',
      name: 'solve',
      component: solve,
      meta:{
        keepAlive: true
      },
    },
    {
      path: '/cn/solution/raas',
      name: 'solution-rass',
      component: solutionRaas,
      meta:{
        keepAlive: true
      },
    },
    {
      path: '/cn/solution/baas',
      name: 'solution-bass',
      component: solutionBaas,
      meta:{
        keepAlive: true
      },
    },
    {
      path: '/cn/about-us',
      name: 'cn-about-us',
      component: AboutCN,
      meta:{
        keepAlive: true
      },
    },
    {
      path: '/cn/blog',
      name: 'BlogCN',
      component: BlogCN,
      meta:{
        keepAlive: true
      },
    },
    {
      path: '/cn/detail',
      name: 'DetailCN',
      component: DetailCN,
      meta:{
        keepAlive: true
      },
    },
    {
      path: '/cloudShop',
      name: 'CloudShop',
      component: CloudShop,
      meta:{
        keepAlive: true
      },
    },
    {
      path: '/customizedReport',
      name: 'CustomizedReport',
      component: CustomizedReport,
      meta:{
        keepAlive: true
      },
    },
    {
      path: '/privateReport',
      name: 'PrivateReport',
      component: PrivateReport,
      meta:{
        keepAlive: true
      },
    },
    {
      path: '/tiktoksupply',
      name: 'Tiktoksupply',
      component: Tiktoksupply,
      meta:{
        keepAlive: true
      },
    },
  ],
  scrollBehavior(to, from, saveTop) {
    // console.log(to, from, saveTop)
    if(to.path === "/cn/how-to-design-a-website") {
      window.location.replace("/cn/detail?paged=/how-to-design-a-website")
    }
    if(to.path === "/login") {
      window.location.replace("https://platform.antdiy.vip/#/")
    }
    if (to.path === "/register") {
      window.location.replace("https://platform.antdiy.vip/#/register")
    }
    if (saveTop) {
      return saveTop;
    } else {
      return { x: 0, y: 0 }
    }
  },
})



// WEBPACK FOOTER //
// ./src/router/index.js